import { MessageCircle } from "lucide-react";
import { Seo } from "@/components/Seo";
import { buildStockWhatsAppUrl } from "@/lib/whatsapp";

function Section({ heading, children }) {
  return (
    <section className="rounded-2xl border border-nm-border bg-nm-surface p-5 sm:p-6">
      <h2 className="text-lg font-bold text-nm-text">{heading}</h2>
      <div className="mt-3 space-y-2.5 text-sm leading-relaxed text-nm-muted">
        {children}
      </div>
    </section>
  );
}

function List({ items }) {
  return (
    <ul className="list-disc space-y-2 pl-5">
      {items.map((t, i) => (
        <li key={i}>{t}</li>
      ))}
    </ul>
  );
}

export default function PrivasiPage() {
  const waUrl = buildStockWhatsAppUrl();
  return (
    <>
      <Seo
        title="Kebijakan Privasi"
        description="Kebijakan privasi Nofina Movie: informasi yang diproses, penggunaan informasi, perlindungan dan pembagian, WhatsApp dan layanan pihak ketiga, serta penyimpanan informasi."
      />
      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <header className="max-w-2xl">
          <h1 className="text-3xl font-extrabold text-nm-text sm:text-4xl">
            Kebijakan Privasi Nofina Movie
          </h1>
          <p className="mt-3 text-nm-muted">
            Nofina Movie menghargai privasi pelanggan dan hanya menggunakan
            informasi yang diperlukan untuk membantu proses pemesanan serta
            layanan pelanggan.
          </p>
        </header>

        <div className="mt-8 space-y-5">
          <Section heading="Informasi yang diproses">
            <List
              items={[
                "Website Nofina Movie tidak mewajibkan pelanggan membuat akun atau login.",
                "Saat pelanggan menekan tombol beli, aplikasi menyiapkan perintah pemesanan berisi kode produk yang dipilih untuk dikirim melalui WhatsApp.",
                "Nofina Movie baru menerima perintah tersebut setelah pelanggan memilih untuk mengirimkannya melalui WhatsApp. Setelah itu, bot WhatsApp membalas dengan detail tagihan dan instruksi pembayaran.",
                "Informasi tambahan yang diberikan pelanggan melalui WhatsApp digunakan untuk konfirmasi pesanan, aktivasi, pembayaran, bantuan, dan penanganan kendala.",
              ]}
            />
          </Section>

          <Section heading="Penggunaan informasi">
            <p>Informasi pelanggan digunakan untuk:</p>
            <List
              items={[
                "Memproses dan mengonfirmasi pesanan.",
                "Memberikan petunjuk aktivasi.",
                "Menjawab pertanyaan dan permintaan bantuan.",
                "Memeriksa serta menangani kendala atau pengajuan garansi.",
                "Menjaga keamanan dan ketertiban proses layanan.",
              ]}
            />
          </Section>

          <Section heading="Perlindungan dan pembagian informasi">
            <List
              items={[
                "Nofina Movie tidak menjual informasi pribadi pelanggan.",
                "Informasi hanya digunakan untuk keperluan operasional layanan dan dapat diproses oleh penyedia layanan yang terlibat dalam komunikasi atau pemenuhan pesanan apabila diperlukan.",
                "Pelanggan tidak boleh mengirimkan password pribadi, PIN, OTP, atau informasi sensitif lain yang tidak diperlukan untuk pemesanan.",
              ]}
            />
          </Section>

          <Section heading="WhatsApp dan layanan pihak ketiga">
            <p>
              Saat pelanggan membuka atau mengirim pesan melalui WhatsApp,
              penggunaan layanan tersebut juga tunduk pada kebijakan
              WhatsApp/Meta. Nofina Movie tidak mengendalikan cara platform
              pihak ketiga memproses data di luar website Nofina Movie.
            </p>
          </Section>

          <Section heading="Penyimpanan informasi">
            <p>
              Riwayat komunikasi dan informasi transaksi dapat disimpan selama
              diperlukan untuk memproses pesanan, memberikan bantuan, menangani
              garansi, serta memenuhi kebutuhan administrasi yang relevan.
            </p>
          </Section>

          <Section heading="Pertanyaan privasi">
            <p>
              Untuk pertanyaan mengenai privasi atau informasi pemesanan,
              pelanggan dapat menghubungi Nofina Movie melalui WhatsApp.
            </p>
          </Section>
        </div>

        <div className="mt-8 rounded-2xl border border-nm-border bg-nm-surface p-6 text-center">
          <a
            href={waUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="privasi-whatsapp"
            className="inline-flex h-12 w-full items-center justify-center gap-2 rounded-lg bg-wa px-6 font-semibold text-white shadow-lg shadow-wa/20 hover:bg-wa-hover sm:w-auto"
          >
            <MessageCircle className="h-5 w-5" />
            Cek Stok via WhatsApp
          </a>
        </div>
      </div>
    </>
  );
}
